<template>
    <div class="field-container-2">
        <div class="regular-type-header">
            {{header}}
        </div>
        <GmapMap :center="center"
                 :zoom="2"
                 map-type-id="terrain"
                 style="height: 300px"
                 @click="mapClickHandler"
        >
            <GmapMarker ref="marker"
                        :position="value"
                        :clickable="true"
                        :draggable="true"
                        @dragend="mapClickHandler"
            />
        </GmapMap>
        <v-text-field
                type="text"
                :hint="description"
                :persistent-hint="true"
                color="accent"
                v-model="textValue"
                :rules="validationRules"
                :required="isRequired"
                @input="inputHandler"
        ></v-text-field>
    </div>

</template>

<script>
    import {
        EVENT_INPUT,
        EVENT_TOUCHED,
        EVENT_VALIDATION_STATE,
        DEFAULT_LOCALE,
        GET_LOCALE_DISPLAY_NAME
    } from '../../services/constants'

    import lodash from '../../services/lodash'

    export default {
        name: 'sfr-location-field',
        props: {
            field: Object,
            valid: Boolean,
            inputValue: String,
        },
        model: {
            prop: 'inputValue',
            event: EVENT_INPUT
        },
        data: function () {
            const value = this.inputValue ? this.latLongStringToLocation(this.inputValue) : {
                lat: 0,
                lng: 0
            }
            return {
                isRequired: this.field.required,
                value: value,
                center: lodash.cloneDeep(value),
                textValue: this.locationToLatLongString(value)
            }
        },
        computed: {
            header: function () {
                return this.computeFieldHeader(this.field)
            },
            isValid: function () {
                return this.valid
            },
            validationRules: function () {
                return [
                    this.isRequired ? v => !!v || `${this.field.name} is required` : () => true,
                ]
            },
            description: function () {
                const currentLocale = this.$store.state.locale.currentLocale
                return currentLocale === DEFAULT_LOCALE ? this.field.description : `${this.field.description} (${this.$store.getters[GET_LOCALE_DISPLAY_NAME](currentLocale)})`
            },
        },
        methods: {
            computeFieldHeader: function (field) {
                return `${field.name}${field.required ? '* ' : ''}:`
            },
            emitInput: function ($event) {
                this.$emit(EVENT_INPUT, $event)
                this.$emit(EVENT_TOUCHED, true)
            },
            inputHandler: function ($event) {
                this.value = this.latLongStringToLocation($event)
                this.emitInput($event)
                this.validate()
            },
            validate: function () {
                const validationResult = !this.validationRules.map(ruleFunc => {
                    const ruleResult = ruleFunc(this.value)
                    if (ruleResult !== true) {
                        this.validationText = ruleResult
                    } else {
                        this.validationText = ''
                    }
                    return ruleResult === true
                }).some(validationResult => {
                    return validationResult === false
                })
                if (validationResult !== this.isValid) {
                    this.emitValidationState(validationResult)
                }
            },

            emitValidationState: function ($event) {
                this.$emit(EVENT_VALIDATION_STATE, $event)
            },

            //takes a location
            locationToLatLongString: function (location) {
                return `${location.lat},${location.lng}`
                // return `${Math.round(location.lat * 100) / 100},${Math.round(location.lng * 100) / 100}`
            },

            latLongStringToLocation: function (latLongString) {
                const arr = latLongString.split(',')
                if (arr.length === 2) {
                    return {
                        lat: Number(arr[0]),
                        lng: Number(arr[1])
                    }
                } else {
                    return null
                }
            },
            mapClickHandler: function ($event) {
                this.value = {
                    lat: $event.latLng.lat(),
                    lng: $event.latLng.lng()
                }
                this.textValue = this.locationToLatLongString(this.value)
                this.emitInput(this.textValue)
                this.validate()
            },
        },
        created: function () {
            this.validate()
        },
    }
</script>

<style scoped lang="scss">
    @import "../../meta";

    .field-container-1 {
        margin: 2em 0;
        .field-container-2 {
            padding: 0 1em;
            $border-width: 3px;
            border-left: $border-width solid $accent;
            border-radius: $border-width;
        }
    }

    .text-long-header {
        font-size: 14px;
        margin: 0 0 1em 0;
    }

    .hint-text {
        color: rgba(0, 0, 0, 0.54);
        font-size: 12px;

        &.custom-validation-error-text {
            color: $error
        }
    }


</style>
